import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory from '../modelFactory';
import fileUploadStateModel, { IFileUploadState } from './fileUploadStateModel';

const SOURCES = [
	'scan',
	'relay',
	'field',
	'cms'
] as const;

type FileSource = typeof SOURCES[number];

const GROUPS = [
	'documents',
	'files',
	'photos',
	'specphotos',
	'signatures'
] as const;

type FileGroup = typeof GROUPS[number];

export interface IFile {
	readonly key?: string;
	readonly createdById?: string;
	readonly dateCreated?: Date;
	rootKey?: string;
	relatedType?: string;
	relatedTypeKey?: string;
	name?: string;
	source?: FileSource;
	group?: FileGroup;
	url?: string;
	uploadState?: IFileUploadState;
	isPdf(): boolean;
	isImage(): boolean;
}

const fileFactory = Object.assign(modelFactory.createFactory<IFile>('File', {
	key: {
		writable: false
	},
	createdById: {
		writable: false
	},
	dateCreated: {
		writable: false,
		setFilters: valueFilters.toUtcDate
	},
	rootKey: {
		setFilters: valueFilters.clean
	},
	relatedType: {
		setFilters: valueFilters.clean
	},
	relatedTypeKey: {
		setFilters: valueFilters.clean
	},
	name: {
		setFilters: valueFilters.clean
	},
	source: {
		setFilters: valueFilters.clean,
		rules: validator.inList(SOURCES)
	},
	group: {
		setFilters: valueFilters.clean,
		rules: validator.inList(GROUPS)
	},
	url: {
		setFilters: valueFilters.clean
	},
	uploadState: {
		setFilters: valueFilters.toModel(fileUploadStateModel)
	},
	isPdf: function () {
		return /\.pdf$/.test(this.name);
	},
	isImage: function () {
		return /\.(jpg|jpeg|png)/.test(this.name);
	}
}), {
	GROUPS,
	SOURCES	
});

export default fileFactory;